<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-3 pr-1 mb-3">
                    <month-picker-input v-model="date" name="date"></month-picker-input>
                </div>
                <div class="col-3 pl-1 mb-3">
                    <button @click.prevent="getResults()" class="btn btn-success mr-2 my-sm-0 formInput" >Search</button>
                    <button @click.prevent="download()" class="btn btn-success formInput" >Download</button>
                </div>
                <div class="col-6 mb-3 text-right">
                    <a class="btn btn-info" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="content">
                <div class="content_header">
                    <h3>চাঁদপুর পৌরসভা</h3>
                    <h4>বিভিন্ন মার্কেটে দাবির রিপোর্ট (সামারী)</h4>
                    <h4 v-if="date.month">মাস : {{ date.month }}, বছর : {{ date.year}}</h4>
                </div>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>মার্কেটের নাম</th>
                            <th class="text-right">বকেয়া</th>
                            <th class="text-right">সারচার্জ</th>
                            <th class="text-right">মাসিক ভাড়া</th>
                            <th class="text-right">অন্যান্য</th>
                            <th class="text-right">মোট</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(val,key) in data" :key="key">
                            <td>{{ key+1}}</td>
                            <td>{{ val.market_name }}</td>
                            <td class="text-right">{{ thousands_separators(getFormatedData(val.due_amount)) }}</td>
                            <td class="text-right">{{ thousands_separators(getFormatedData(val.due_charge)) }}</td>
                            <td class="text-right">{{ thousands_separators(getFormatedData(val.amount)) }}</td>
                            <td class="text-right">0</td>
                            <td class="text-right">{{ thousands_separators(getFormatedData(val.total)) }}</td>
                        </tr>
                        <tr>
                            <td class="text-right" v-if="dueAmount" colspan="2">মোট :</td>
                            <td class="text-right" v-if="dueAmount">{{ thousands_separators(getFormatedData(dueAmount)) }}</td>
                            <td class="text-right" v-if="dueCharge">{{ thousands_separators(getFormatedData(dueCharge)) }}</td>
                            <td class="text-right" v-if="Amount">{{ thousands_separators(getFormatedData(Amount)) }}</td>
                            <td class="text-right" v-if="Amount">0</td>
                            <td class="text-right" v-if="Total">{{ thousands_separators(getFormatedData(Total)) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { MonthPickerInput } from 'vue-month-picker'
import axios from 'axios';
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

export default {
    name: "MarketWiseDemandSummary",
    data(){
        return {
            date: {
                from: null,
                to: null,
                month: null,
                year: null,
            },
            data:{},
            dueAmount:'',
            dueCharge:'',
            Amount:'',
            Total:'',
        }
    },
    methods:{
        async loadContents(){
            var start = ''
            var end = ''
            var month = ''
            var year =  ''
            if(this.date.from){
                start = this.date.from
                end = this.date.to
                month = this.date.month
                year = this.date.year
            }
            //console.log(year)
            var cont = {start,end,month,year};

            axios.post('/api/market-wise-demand-summary',cont).then(response=>{
                this.data = response.data.bills
                this.month = response.data.month
                this.year = response.data.year
                this.dueAmount = response.data.dueAmount
                this.dueCharge = response.data.dueCharge
                this.Amount = response.data.Amount
                this.Total = response.data.Total
            })
        },
        async getResults(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.loadContents()
                }
            })
        },
        getFormatedData(val) {
            return val.toFixed(2);
        },
        thousands_separators(num){
            var num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num_parts.join(".");
        },
        download(){
            var start = ''
            var end = ''
            var month = ''
            var year =  ''
            if(this.date.from){
                start = this.date.from
                end = this.date.to
                month = this.date.month
                year = this.date.year
            }
            var start_date = new Date(start).toLocaleString('en-US', { timeZone: 'Asia/Dhaka'})
            var end_date = new Date(end).toLocaleString('en-US', { timeZone: 'Asia/Dhaka'})
            //console.log(start_date)
            //console.log(start | moment('timezone', 'Asia/Dhaka', 'd.MM.Y'))
            //d.toLocaleString('en-US', { timeZone: 'America/New_York' });

            var download = 'download'
            let getUserInfo = JSON.parse(localStorage.getItem('user'))
            let loggedUser = getUserInfo.name

            window.open(`${axios.defaults.baseURL}/api/market-wise-demand-summary?download=${download}&loggeduser=${loggedUser}&start=${start_date}&end=${end_date}&month=${month}&year=${year}`)

        },
    },
    mounted(){
        //this.getResults()
    },
    computed:{
    },
    components: {
        MonthPickerInput
    }
}
</script>
<style scoped>
.formInput{ height: 41px;}
.date-time-picker label,.card{font-family: 'Hind Siliguri Light' !important; font-size: 16px;}
.form-control{ font-size: 16px;}
.content_header{ text-align: center; border:1px solid #999; padding:10px; margin-bottom: 15px; background: #f7f7f7;}
h3{ font-size: 16px;font-family: 'Kalpurush', Arial, sans-serif !important; margin:0 0 5px 0;}
.content_header h3{ font-size: 20px;font-family: 'Kalpurush', Arial, sans-serif !important; margin:0;}
.content_header h4{ font-size: 16px;font-family: 'Kalpurush', Arial, sans-serif !important; margin:0;}
table{ border: 1px solid #999;font-family: 'Kalpurush', Arial, sans-serif !important;}
table th, td{ border: 1px solid #999;}
table thead tr th,table thead tr td{ text-align: center;}
/* table tbody tr:last-child td{ border:0; background: #f7f7f7;} */
table thead tr th{ background: #f7f7f7;}
.btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}

</style>
